import getPosInfo from './getPosInfo'
import intersectMeshes from './intersectMeshes';

const getTypeFace = (face) => {

    //выясняем что за грань
    let typeFace = '';

    if (
        parseInt(face.rotate_x) === 0 &&
        parseInt(face.rotate_y) === 0 &&
        parseInt(face.rotate_z) === 0
    ) {
        typeFace = 'front';
    }

    if (
        parseInt(face.rotate_x) === 0 &&
        parseInt(face.rotate_y) === 180 &&
        parseInt(face.rotate_z) === 0
    ) {
        typeFace = 'back';
    }

    if (
        parseInt(face.rotate_x) === 0 &&
        parseInt(face.rotate_y) === 90 &&
        parseInt(face.rotate_z) === 0
    ) {
        typeFace = 'left';
    }

    if (
        parseInt(face.rotate_x) === 0 &&
        parseInt(face.rotate_y) === -90 &&
        parseInt(face.rotate_z) === 0
    ) {
        typeFace = 'right';
    }

    if (
        parseInt(face.rotate_x) === -90 &&
        parseInt(face.rotate_y) === 0 &&
        parseInt(face.rotate_z) === 0
    ) {
        typeFace = 'top';
    }

    return typeFace;
}

export const prepareEngraving = async (fEl, model, mesh, face, distance) => {

    model.updateMatrix();

    const modelBbox = getPosInfo(model);
    let meshBbox = getPosInfo(mesh);

    const heDoShag = 0.0001;

    const offsetTop = +fEl.offsetTop / 100;
    const offsetLeft = +fEl.offsetLeft / 100;

    const typeFace = getTypeFace(face);

    if (fEl.mirrored) {
        mesh.rotation.y = Math.PI;
    }

    if (typeFace === 'front') {
        if (fEl.angle) {
            mesh.rotation.z = (parseFloat(fEl.angle) / 180) * Math.PI;
            meshBbox = getPosInfo(mesh);
        }

        if (fEl.isText) {
            // FIX: НЕ конвертируем троика-текст через textToMesh()
            // Troika-three-text использует специальную GlyphsGeometry и ShaderMaterial,
            // которые несовместимы с BufferGeometryUtils.mergeBufferGeometries()
            // Вместо этого работаем напрямую с троика-текстом

            // Troika-текст использует anchor для позиционирования:
            // anchorX: 'left' означает, что position.x это левый край текста
            // anchorY: 'top' означает, что position.y это верхний край текста
            // По умолчанию anchor находится в центре

            // Устанавливаем anchor в левый-верхний угол для удобства позиционирования
            mesh.anchorX = 'left';
            mesh.anchorY = 'top';

            // Позиция: от левого-верхнего угла модели + смещения
            mesh.position.x = modelBbox.bbox.min.x + offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - offsetTop;
            // Z: на поверхности передней грани + layer
            mesh.position.z = modelBbox.bbox.max.z + fEl.layer + heDoShag;

            mesh.updateMatrix();
        } else {

            mesh.position.x = modelBbox.bbox.min.x + meshBbox.xSize / 2 + offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - meshBbox.ySize / 2 - offsetTop;

            // FIX: Всегда размещаем гравировку на поверхности модели для CSG intersect
            mesh.position.z = modelBbox.bbox.max.z - heDoShag;
            mesh.updateMatrix();

            mesh = await intersectMeshes(model, mesh);

            // Финальное смещение: layer + небольшой отступ от поверхности
            mesh.position.z = mesh.position.z + meshBbox.zSize / 2 + fEl.layer;

            mesh.updateMatrix();
        }
    }

    if (typeFace === 'back') {

        mesh.rotation.y = Math.PI;

        if (fEl.angle) {
            mesh.rotation.z = (parseFloat(fEl.angle) / 180) * Math.PI;
        }

        mesh.updateMatrix();

        meshBbox = getPosInfo(mesh);

        if (fEl.isText) {
            mesh.position.x = modelBbox.bbox.max.x - offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - offsetTop;
            // FIX: Всегда размещаем текст на поверхности задней грани
            mesh.position.z = modelBbox.bbox.min.z - fEl.layer;
        } else {
            if (fEl.mirrored) {
                mesh.rotation.y = 0;
            }
            mesh.position.x = modelBbox.bbox.max.x - meshBbox.xSize / 2 - offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - meshBbox.ySize / 2 - offsetTop;

            // FIX: Всегда размещаем гравировку на поверхности модели для CSG intersect
            mesh.position.z = modelBbox.bbox.min.z + heDoShag;
            mesh.updateMatrix();

            mesh = await intersectMeshes(model, mesh);

            // Финальное смещение
            mesh.position.z = mesh.position.z - meshBbox.zSize / 2 - fEl.layer - heDoShag;

            mesh.updateMatrix();
        }
    }

    if (typeFace === 'left') {
        mesh.rotation.y = Math.PI / 2;
        mesh.updateMatrix();
        meshBbox = getPosInfo(mesh);
        if (fEl.angle) {
            mesh.rotation.x = (parseFloat(fEl.angle) / 180) * Math.PI;
        }
        if (fEl.isText) {

            mesh.position.z = modelBbox.bbox.max.z - offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - offsetTop;
            // FIX: Всегда размещаем текст на поверхности левой грани
            mesh.position.x = modelBbox.bbox.max.x + fEl.layer;

        } else {
            if (fEl.mirrored) {
                mesh.rotation.y = 0 + Math.PI / 2 + Math.PI;
            }

            mesh.position.z = modelBbox.bbox.max.z - meshBbox.zSize / 2 - offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - meshBbox.ySize / 2 - offsetTop;

            mesh.updateMatrix();

            mesh = await intersectMeshes(model, mesh)

            // FIX: Всегда размещаем элемент на поверхности левой грани
            mesh.position.x = modelBbox.bbox.max.x + fEl.layer;

            mesh.updateMatrix();
        }
    }

    if (typeFace === 'right') {
        mesh.rotation.y = -Math.PI / 2;
        mesh.updateMatrix();
        meshBbox = getPosInfo(mesh);

        if (fEl.angle) {
            mesh.rotation.x = -(parseFloat(fEl.angle) / 180) * Math.PI;
        }
        if (fEl.isText) {
            mesh.position.z = modelBbox.bbox.min.z + offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - offsetTop;
            // FIX: Всегда размещаем текст на поверхности правой грани
            mesh.position.x = modelBbox.bbox.min.x - fEl.layer;
        } else {
            if (fEl.mirrored) {
                mesh.rotation.y = 0 - Math.PI / 2 + Math.PI;
                mesh.updateMatrix();
            }
            mesh.position.z = modelBbox.bbox.min.z + meshBbox.zSize / 2 + offsetLeft;
            mesh.position.y = modelBbox.bbox.max.y - meshBbox.ySize / 2 - offsetTop;

            mesh.updateMatrix();

            mesh = await intersectMeshes(model, mesh)

            // FIX: Всегда размещаем элемент на поверхности правой грани
            mesh.position.x = modelBbox.bbox.min.x - fEl.layer;

            mesh.updateMatrix();
        }

    }

    if (typeFace === 'top') {
        mesh.rotation.x = -Math.PI / 2;
        mesh.updateMatrix();

        meshBbox = getPosInfo(mesh);
        if (fEl.angle) {
            mesh.rotation.z = (parseFloat(fEl.angle) / 180) * Math.PI;
        }

        if (fEl.isText) {

            mesh.position.z = modelBbox.bbox.min.z + offsetTop;
            mesh.position.x = modelBbox.bbox.min.x + offsetLeft;
            // FIX: Всегда размещаем текст на поверхности верхней грани
            mesh.position.y = modelBbox.bbox.max.y + fEl.layer;

        } else {
            mesh.position.z = modelBbox.bbox.min.z + meshBbox.zSize / 2 + offsetTop;
            mesh.position.x = modelBbox.bbox.min.x + meshBbox.xSize / 2 + offsetLeft;

            // FIX: Всегда размещаем элемент на поверхности верхней грани
            mesh.position.y = modelBbox.bbox.max.y - heDoShag;
            mesh.updateMatrix();

            mesh = await intersectMeshes(model, mesh)
            mesh.position.y = mesh.position.y + fEl.layer + heDoShag;

            mesh.updateMatrix();
        }

    }

    // Преобразуем мировые координаты в локальные относительно модели
    // Это необходимо, так как mesh будет добавлен как дочерний элемент модели
    // для корректного вращения вместе с моделью
    model.updateMatrixWorld(true);
    const worldPosition = mesh.position.clone();
    const localPosition = model.worldToLocal(worldPosition);
    mesh.position.copy(localPosition);

    // Поворот mesh уже установлен для конкретной грани
    // Не нужно компенсировать поворот модели, так как дочерний элемент
    // автоматически поворачивается вместе с родителем

    mesh.updateMatrix();

    return mesh;
}
